"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Navbar_1 = __importDefault(require("../components/Navbar"));
require("../assets/styles/bottomNav.css");
var material_1 = require("@mui/material");
var wishlistcard_1 = __importDefault(require("../components/wishlist/wishlistcard"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var AxiosClient_1 = require("../utils/AxiosClient");
var js_cookie_1 = __importDefault(require("js-cookie"));
var react_hot_toast_1 = require("react-hot-toast");
function WishList() {
    var _a = (0, react_1.useState)([]), wishitems = _a[0], setItems = _a[1];
    var _b = (0, react_1.useState)(true), loading = _b[0], setLoading = _b[1];
    function getCookie(name) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
        var gettoken = js_cookie_1.default.get(name);
        return gettoken;
    }
    var token = getCookie("token");
    if (token == undefined) {
        window.location.href = "/login";
    }
    var handleDelete = function (id) {
        setItems(wishitems.filter(function (item) { return item.ProductID != id; }));
    };
    console.log("getting the data:");
    (0, react_1.useEffect)(function () {
        if (token) {
            AxiosClient_1.AxiosClient.get("/products/wishlist/view", {
                headers: {
                    Authorization: "Bearer ".concat(token),
                },
            })
                .then(function (response) {
                if (response.data.status == 200) {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                    setItems(response.data.data[0].WishlistItems);
                    setLoading(false);
                }
            })
                .catch(function (error) {
                console.log(error);
            });
        }
    }, []);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(react_hot_toast_1.Toaster, null),
        react_1.default.createElement(Navbar_1.default, { iconNumber: 5 }),
        react_1.default.createElement("div", { className: "secondoption" },
            react_1.default.createElement(material_1.Typography, { component: "div", variant: "h3", color: "primary", sx: { fontWeight: 600, textAlign: "center" } }, "Wishlist")),
        loading ? (react_1.default.createElement(Box_1.default, { sx: {
                width: "100%",
                height: "100%",
                left: "unset",
                display: "flex",
                alignItems: "center",
            } },
            react_1.default.createElement(Box_1.default, { sx: { width: "100%", display: "flex", alignItems: "center" } },
                react_1.default.createElement(material_1.CircularProgress, { color: "primary", sx: { zIndex: "100", margin: "auto" } })))) : (react_1.default.createElement(react_1.default.Fragment, null)),
        react_1.default.createElement(Box_1.default, { sx: {
                diplay: "flex",
                flexDirection: "column",
                width: "90%",
                margin: "10px auto",
            } }, wishitems ? (wishitems.map(function (item, index) {
            return (react_1.default.createElement(wishlistcard_1.default, { key: index, items: wishitems, id: item.id, productId: item.ProductID, name: item.Product.ProductName, description: item.Product.ProductDesc, price: item.Product.ProductPrice, image: item.Product.pro_images[0].ImagePath, Delete: handleDelete }));
        })) : (react_1.default.createElement("h1", null, "No Items are in your wish list collection")))));
}
exports.default = WishList;
